// Generated by ReScript, PLEASE EDIT WITH CARE


function get() {
  return window.navigator.userAgent;
}

export {
  get,
}
/* No side effect */
